import React, { useEffect, useState } from 'react';
import { Grid, Typography, Box, Paper } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import ControlledTextInputField from '../../component/ui/FormFields/ControlledTextInputField';
import CustomButton from '../../component/ui/FormFields/Button';
import {
  addAirportRequest,
  resetAirportState,
} from '../../redux/Airports/actions/airportActions';
import {
  selectCountryAirportRequest,
  selectStateAirportRequest,
} from '../../redux/Common/selectorAction';

import { AIRPORTS } from '../../component/common/Routes/AppRoutes';
import { useNavigate } from 'react-router-dom';
import {
  LocationOn,
  FlightLand,
  FlightTakeoff,
  TransferWithinAStation,
} from '@mui/icons-material';
import { fetchAllServiceRequest } from '../../redux/Service/ServiceAction';

export default function AddAirport() {
  const dispatch = useDispatch();
  const {
    control,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {},
    mode: 'onChange',
  });
  const formValue = watch();
  useEffect(() => {
    dispatch(resetAirportState());
    dispatch(selectCountryAirportRequest());
  }, []);
  useEffect(() => {
    dispatch(fetchAllServiceRequest());
  }, [formValue?.airport_type]);
  const ServiceDetails = useSelector(
    (state) => state.services?.ServiceDetails?.data || {}
  );

  const filteredServiceDetails = ServiceDetails.filter((service) => {
    if (service?.status === 1 && service?.approoved_status === 1) {
      return {
        service,
      };
    }
  });

  const filterServiceBasedOnAirportType = filteredServiceDetails.filter(
    (service) => {
      if (formValue?.airport_type?.label === 'Both') {
        return { service };
      } else if (
        formValue?.airport_type?.label === 'International' &&
        service?.type_of_service === 'International'
      ) {
        return { service };
      } else if (
        formValue?.airport_type?.label === 'Domestic' &&
        service?.type_of_service === 'Domestic'
      ) {
        return { service };
      }
    }
  );

  const services = filterServiceBasedOnAirportType
    .filter((service) => service.arrival_departure_type !== 3)
    .map((service) => {
      return {
        value: service.id,
        label: `${service.services} - ${service.type_of_name} - ${service.type_of_service}`,
        serviceType: service.arrival_departure_type || 1,
      };
    });

  const transitServices = filterServiceBasedOnAirportType
    .filter((service) => service.arrival_departure_type === 3)
    .map((service) => ({
      value: service.id,
      label: `${service.services} - ${service.type_of_name} - ${
        service.type_of_service
      } - ${
        service.transit_type_of_service
          ? service.transit_type_of_service
          : 'Unknown'
      }`,
      serviceType: 3,
    }));

  const allServices = [...services, ...transitServices];

  const navigate = useNavigate();
  const { airport } = useSelector((state) => state.airport);
  const addLoading = airport?.loading;
  const countries = useSelector((state) => state.selector?.country?.data);
  const states = useSelector((state) => state.selector?.state?.data);
  const successMessage = airport?.success;
  const errorMessage = airport?.error;

  const airportTypeOptions = [
    { value: '1', label: 'Domestic' },
    { value: '2', label: 'International' },
    { value: '3', label: 'Both' },
  ];
  useEffect(() => {
    if (successMessage) {
      toast.success('Airport Inserted Successfully', {
        position: 'top-center',
        autoClose: 3000,
        onClose: () => navigate(AIRPORTS),
      });
      dispatch(resetAirportState());
    }
  }, [successMessage]);
  useEffect(() => {
    if (errorMessage) {
      toast.error('Airport Insert Failed', {
        position: 'top-center',
        autoClose: 3000,
        onClose: () => dispatch(resetAirportState()),
      });
    }
  }, [errorMessage]);
  const countryId = watch('country_id')?.value;
  const countryOptions = countries?.map((country) => ({
    value: country.id,
    label: country.country_name,
  }));

  const stateOptions = states?.map((state) => ({
    value: state.id,
    label: state.state_name,
  }));

  useEffect(() => {
    if (countryId > 0) {
      setValue('state_id', '');

      dispatch(selectStateAirportRequest(countryId));
    }
  }, [countryId]);

  useEffect(() => {
    setValue('service_ids', '');
  }, [formValue?.airport_type]);

  const airportFields = [
    {
      name: 'name',
      label: 'Airport Name *',
      placeholder: 'Enter Airport Name',
      rules: { required: 'Airport Name is required' },
      sm: 6,
    },
    {
      name: 'short_name',
      label: 'Airport Code *',
      placeholder: 'Enter Airport Code',
      rules: {
        required: 'Airport Code is required',
        pattern: {
          value: /^[a-zA-Z0-9]{1,5}$/,
          message:
            'Airport Code must be between 1 and 5 alphanumeric characters',
        },
      },
      sm: 6,
    },
    {
      name: 'airport_type',
      label: 'Airport Type',
      placeholder: 'Select Airport Type',
      options: airportTypeOptions,
      icon: <LocationOn />,
      rules: { required: 'Select Airport Type' },
      sm: 6,
    },

    {
      name: 'country_id',
      label: 'Country *',
      placeholder: 'Select country',
      rules: { required: 'Country is required' },
      options: countryOptions,
      sm: 6,
    },

    {
      name: 'state_id',
      label: 'State *',
      placeholder: 'Select state',
      rules: { required: 'State is required' },
      options: stateOptions,

      sm: 6,
    },
    {
      name: 'service_ids',
      label: 'Service *',
      rules: { required: 'service is required' },
      options: allServices,
      multiple: true,
      placeholder: 'Select Service ',
      sm: 6,
    },
  ];

  const indiaSpecificFields = [
    {
      name: 'sgst',
      label: 'SGST (%) *',
      placeholder: 'Enter SGST',
      type: 'number',
      rules: {
        required: 'SGST is required',
        validate: {
          isNumber: (value) => !isNaN(value) && value !== '',
          range: (value) =>
            (parseFloat(value) >= 0 && parseFloat(value) <= 100) ||
            'SGST must be between 0 and 100',
        },
      },
      sm: 6,
    },
    {
      name: 'cgst',
      label: 'CGST (%) *',
      placeholder: 'Enter CGST',
      type: 'number',
      rules: {
        required: 'CGST is required',
        validate: {
          isNumber: (value) => !isNaN(value) && value !== '',
          range: (value) =>
            (parseFloat(value) >= 0 && parseFloat(value) <= 100) ||
            'CGST must be between 0 and 100',
        },
      },
      sm: 6,
    },
  ];

  const commissionField = [
    {
      name: 'tax',
      label: 'IGST (%) *',
      placeholder: 'Enter IGST',
      type: 'number',
      rules: {
        required: 'IGST is required',
        validate: {
          isNumber: (value) => !isNaN(value) && value !== '',
          range: (value) =>
            (parseFloat(value) >= 0 && parseFloat(value) <= 100) ||
            'IGST must be between 0 and 100',
        },
      },
      sm: 12,
    },
  ];

  const additionalFields =
    countryId === 101 ? indiaSpecificFields : commissionField;
  const onSubmit = (data) => {
    const requestData = {
      ...data,
      country_id: data.country_id.value,
      state_id: data.state_id.value,
      type: data.airport_type.value,
      service_ids: data.service_ids?.map((service) => {
        const isTransit = service.serviceType === 3;
        return {
          service_id: service.value,
          price: data[`price_${service.value}`],
          arrival: isTransit
            ? ''
            : data[`arrival_description_${service.value}`] || '',
          departure: isTransit
            ? ''
            : data[`departure_description_${service.value}`] || '',
          transit: isTransit
            ? data[`transit_description_${service.value}`] || ''
            : '',
        };
      }),
      type: data.airport_type?.value,
      sgst: data.sgst || 0,
      cgst: data.cgst || 0,
      tax: data.tax || 0,
      status: '1',
    };

    dispatch(addAirportRequest(requestData));
  };

  const selectedServices = watch('service_ids') || [];

  return (
    <Box component={Paper} sx={{ margin: '30px', padding: '30px' }}>
      <Typography variant='h5' mb={2}>
        Add Airport
      </Typography>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          {airportFields.map((field) => (
            <Grid item xs={12} sm={field.sm} key={field.name}>
              <ControlledTextInputField
                name={field.name}
                control={control}
                label={field.label}
                multiple={field.multiple}
                placeholder={field.placeholder}
                options={field.options}
                rules={field.rules}
                type={field.type}
                error={!!errors[field.name]}
                helperText={errors[field.name]?.message}
              />
            </Grid>
          ))}

          {additionalFields.map((field) => (
            <Grid item xs={12} sm={field.sm} key={field.name}>
              <ControlledTextInputField
                name={field.name}
                control={control}
                label={field.label}
                placeholder={field.placeholder}
                rules={field.rules}
                error={!!errors[field.name]}
                type={field.type}
                helperText={errors[field.name]?.message}
              />
            </Grid>
          ))}

          {selectedServices.map((service) => {
            const isTransit = service.serviceType === 3;

            return (
              <React.Fragment key={`service-group-${service.value}`}>
                <Grid item xs={12}>
                  <Typography
                    variant='subtitle1'
                    sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}
                  >
                    Service: {service.label}
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={12}>
                  <ControlledTextInputField
                    name={`price_${service.value}`}
                    control={control}
                    label='Price *'
                    placeholder='Enter Price'
                    type='text'
                    rules={{
                      required: 'Price is required',
                      validate: {
                        isNumber: (value) => !isNaN(value) && value !== '',
                        positive: (value) =>
                          parseFloat(value) > 0 ||
                          'Price must be greater than 0',
                      },
                    }}
                    error={!!errors[`price_${service.value}`]}
                    helperText={errors[`price_${service.value}`]?.message}
                  />
                </Grid>

                {isTransit ? (
                  <Grid item xs={12} sm={12}>
                    <ControlledTextInputField
                      name={`transit_description_${service.value}`}
                      control={control}
                      label='Transit Description'
                      placeholder='Enter Transit Description'
                      multiline={true}
                      startAdornment={<TransferWithinAStation />}
                      error={!!errors[`transit_description_${service.value}`]}
                      helperText={
                        errors[`transit_description_${service.value}`]?.message
                      }
                    />
                  </Grid>
                ) : (
                  <>
                    <Grid item xs={12} sm={6}>
                      <ControlledTextInputField
                        name={`arrival_description_${service.value}`}
                        control={control}
                        label='Arrival Description'
                        placeholder='Enter Arrival Description'
                        multiline={true}
                        startAdornment={<FlightLand />}
                        error={!!errors[`arrival_description_${service.value}`]}
                        helperText={
                          errors[`arrival_description_${service.value}`]
                            ?.message
                        }
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <ControlledTextInputField
                        name={`departure_description_${service.value}`}
                        control={control}
                        label='Departure Description'
                        placeholder='Enter Departure Description'
                        multiline={true}
                        startAdornment={<FlightTakeoff />}
                        error={
                          !!errors[`departure_description_${service.value}`]
                        }
                        helperText={
                          errors[`departure_description_${service.value}`]
                            ?.message
                        }
                      />
                    </Grid>
                  </>
                )}
              </React.Fragment>
            );
          })}

          <Grid item xs={12}>
            <Box className='button-container'>
              <CustomButton
                variant='contained'
                className='cancel-button'
                type='button'
                text='Back'
                onClick={() => {
                  dispatch(resetAirportState());
                }}
                link={AIRPORTS}
              />
              <CustomButton
                variant='contained'
                className='success-button'
                type='submit'
                loading={addLoading}
                text={'Submit'}
              />
            </Box>
          </Grid>
        </Grid>
      </form>
      <ToastContainer />
    </Box>
  );
}
